module.exports = __webpack_public_path__ + "static/media/photo-grey.79a4f6bb.jpg";